import { render, staticRenderFns } from "./AsEmployeePageHeader.vue?vue&type=template&id=2fbd1983&scoped=true"
import script from "./AsEmployeePageHeader.vue?vue&type=script&lang=js"
export * from "./AsEmployeePageHeader.vue?vue&type=script&lang=js"
import style0 from "./AsEmployeePageHeader.vue?vue&type=style&index=0&id=2fbd1983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd1983",
  null
  
)

export default component.exports